import { render, staticRenderFns } from "./MasterLayout.vue?vue&type=template&id=05b71906&scoped=true&"
import script from "./MasterLayout.vue?vue&type=script&lang=ts&"
export * from "./MasterLayout.vue?vue&type=script&lang=ts&"
import style0 from "./MasterLayout.vue?vue&type=style&index=0&id=05b71906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b71906",
  null
  
)

export default component.exports